import React, { memo, useMemo } from 'react';
import type { ThemeColors } from '../../shared/theme';
import { useTranslation } from '../../shared/i18n';
import { JOURNEY_ACTIVITY_OPTIONS } from '../../data/domains/journey';
import { JourneyOptionStep, type JourneyOptionItem } from './JourneyOptionStep';

type Props = {
  colors: ThemeColors;
  activity: string;
  on_select_activity: (id: string) => void;
};

export const JourneyActivityStep = memo(function JourneyActivityStep({
  colors,
  activity,
  on_select_activity,
}: Props) {
  const { t } = useTranslation();

  const options = useMemo<JourneyOptionItem[]>(
    () =>
      JOURNEY_ACTIVITY_OPTIONS.map(option => ({
        id: option.id,
        labelKey: option.labelKey,
        subtitleKey: option.subtitleKey,
        icon: option.icon,
        tone: option.tone,
      })),
    [],
  );

  return (
    <JourneyOptionStep
      colors={colors}
      title={t('journey.activityLevel')}
      subtitle={t('journey.howActiveEachWeek')}
      options={options}
      selected_id={activity}
      on_select={on_select_activity}
      accessibility_label={t('journey.activityLevel')}
      test_id_prefix="journey-activity"
    />
  );
});
